import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';
import bindModel from '../../../common/bindModel.js';

const $ = window.$;
export default class ModalCreatePopupLuckyGift extends Component {
    constructor(props) {
        super(props);

        this.state = {
            idUser: "",
            uidTarget: 0,
            kindTarget: "LiveRoom",
            loading: false
        }

        this.addRelatedUser = this.addRelatedUser.bind(this);
    }

    addRelatedUser(event) {
        if(event.key == 'Enter' || event.target.tagName == "BUTTON") {
            this.setState({
                loading: true
            });

            var json = {
                idUser: this.props.id,
                uidTarget: Number(this.state.uidTarget),
                kindTarget: this.state.kindTarget
            }
            // console.log(json)
            console.log(JSON.stringify(json))
            axios.post(global.config.apiDomain + '/rest/admin/createNotificationLuckyGift', JSON.stringify(json), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                this.setState({
                    loading: false
                });

                if(res.data.status == "OK") {
                    $("#modalCreatePopupLuckyGift").modal("hide");
                    toast.success(res.data.message);
                } else {
                    toast.warning(res.data.message); 
                }
            }, error => {
                this.setState({
                    loading: false
                });
                toast.error("ERROR"); 
            })
        }
    }

    render() {
        const model = bindModel(this);

        return (
            <div>
                <div className="modal fade" id="modalCreatePopupLuckyGift" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Nhập thông tin</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                            <label>Nơi đến</label>
                            <select 
                                className="form-control"
                                {...model('kindTarget')}>
                                <option value="LiveRoom">Phòng kara</option>
                                <option value="Recording">Bài thu</option>
                            </select>
                            </div>


                            <div className="modal-body">
                            <label>Nhập ID</label>
                                <input
                                    onKeyUp={this.addRelatedUser} 
                                    type="number" 
                                    placeholder="Nhập ID phòng live hoặc bài thu"
                                    className="form-control"
                                    {...model('uidTarget')}/>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.addRelatedUser}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}